import React from 'react';
import axios from 'axios';
import { API_BASE_URL } from '@config';
import * as ActionsDialog from 'app/store/actions';
import { showMessage } from 'app/store/actions/fuse';
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle, Icon, Typography } from '@material-ui/core';
import Logs from '../../Logs';

// SET
export const SET_STACKS_LIST = 'SET_STACKS_LIST';
export const setStacksList = stacks => ({
	type: SET_STACKS_LIST,
	payload: stacks
});

export const SET_STACK = 'SET_STACK';
export const setStack = stack => ({
	type: SET_STACK,
	payload: stack
});

export const SET_OS_TYPES = 'SET_OS_TYPES';
export const setProviderOsTypes = os_types => ({
	type: SET_OS_TYPES,
	payload: os_types
});

export const SET_IMAGES_INFO = 'SET_IMAGES_INFO';
export const setImagesInfo = images_info => ({
	type: SET_IMAGES_INFO,
	payload: images_info
});

export const SET_ACM_IMAGES = 'SET_ACM_IMAGES';
export const setAcmImages = images => ({
	type: SET_ACM_IMAGES,
	payload: images
});

export const SET_ACM_SHAPES = 'SET_ACM_SHAPES';
export const setAcmShapes = images => ({
	type: SET_ACM_SHAPES,
	payload: images
});

export const SET_SELECTED = 'SET_SELECTED';
export const setSelected = stack => ({
	type: SET_SELECTED,
	payload: stack
});

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const setSearchText = event => ({
	type: SET_SEARCH_TEXT,
	searchText: event.target.value
});

export const SET_STACK_ERROR = 'SET_STACK_ERROR';
export const setStackError = error => ({
	type: SET_STACK_ERROR,
	payload: error
});

export const SET_LOGS = 'SET_LOGS';
export const setLogs = logs => ({
	type: SET_LOGS,
	payload: logs
});
// CLEAR
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const clearError = () => ({
	type: CLEAR_ERROR
});

export const CLEAR_STACK = 'CLEAR_STACK';
export const clearStack = () => ({
	type: CLEAR_STACK
});

export const CLEAR_STACKS_REDUCER = 'CLEAR_STACKS_REDUCER';
export const clearStacksReducer = () => ({
	type: CLEAR_STACKS_REDUCER
});

export const CLEAR_LOGS = 'CLEAR_LOGS';
export const clearLogs = () => ({
	type: CLEAR_LOGS
});

// * ////////////// HEADERS ////////////// * //
const headers = {
	headers: {
		admin: true
	}
};
const repeatHeader = {
	headers: {
		repeatCall: true
	}
};

// * ////////////// NEW ////////////// * //

export const newStack = () => dispatch => {
	const data = {
		builder: 'market',
		credential_id: '',
		data: {
			manager: 'torque',
			customize_image: false,
			disk_size: '',
			instance_id: '',
			isPrivate: false,
			minimal: false,
			prefix: 'core',
			proxy: '',
			region_id: '',
			resource_group_name: '',
			security_group_id: '',
			service_account: false,
			source_image: '',
			source_image_offer: '',
			source_image_publisher: '',
			source_image_sku: '',
			source_os_type: '',
			source_resource_group_name: '',
			ssh_username: '',
			subnet_id: '',
			subnet_network_id: '',
			type: '',
			volume_size: '',
			zone_id: '',
			features: [],
			mem: null,
			ocpus: null,
			provision: {
				nodeProvisioner: '',
				serverProvisioner: '',
				dataFiles: [],
				dataFilesB: []
			},
			rhel: {
				activation_key: null,
				organization_id: null,
			},
			vpc_id: '',
		},
		description: '',
		name: '',
		provider: ''
	};

	dispatch(setStack(data));
};

// * ////////////// REPEATS ////////////// * //

export const getStacksRepeat = () => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/stacks/`, repeatHeader);
	return request
		.then(res => dispatch(setStacksList(res.data)))
		.catch(err => dispatch(setStackError({ ...err.data, type: 'modal' })));
};

export const getLogsRepeat = params => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/stacks/logs/${params.id}/${params.type}`, repeatHeader);
	return request
		.then(res => dispatch(setLogs(res.data.logs)))
		.catch(err => dispatch(setStackError({ ...err.data, type: 'modal' })));
};

// * ////////////// GET ////////////// * //

export const getStacks = () => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/stacks/`);
	return request
		.then(response => dispatch(setStacksList(response.data)))
		.then(() => dispatch(ActionsDialog.toggleLoading()))
		.catch(err => dispatch(setStackError({ ...err.data, type: 'modal' })));
};

export const getStack = data => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/stacks/${data.id}`);
	return request
		.then(response => {
			dispatch(setStack(response.data));
			dispatch(ActionsDialog.toggleLoading());
		})
		.catch(err => {
			dispatch(setStackError(err.data));
			dispatch(ActionsDialog.toggleLoading());
		});
};
export const provider_os_types = (provider) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/stacks/provider_os_type/${provider}`);
	return request
		.then(response => dispatch(setProviderOsTypes(response.data)))
		.then(() => dispatch(ActionsDialog.toggleLoading()))
		.catch(err => dispatch(setStackError({ ...err.data, type: 'modal' })));
};
export const images_info = (provider) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/stacks/images_info/${provider}`);
	return request
		.then(response => dispatch(setImagesInfo(response.data)))
		.then(() => dispatch(ActionsDialog.toggleLoading()))
		.catch(err => dispatch(setStackError({ ...err.data, type: 'modal' })));
};

export const getLogs = params => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/stacks/logs/${params.id}/${params.type}`);
	return request
		.then(response => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setLogs(response.data.logs));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setStackError({ ...err.data, type: 'modal' }));
		});
};

// get ACM images 
export const getAcmImages = () => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/stacks/acm_images`);
	return request
		.then(response => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setAcmImages(response.data));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setStackError({ ...err.data, type: 'modal' }));
		});
}


// get ACM shapes 
export const getAcmShapes = () => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/stacks/acm_shapes`);
	return request
		.then(response => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setAcmShapes(response.data));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setStackError({ ...err.data, type: 'modal' }));
		});
}

// * ////////////// POST ////////////// * //

export const saveStack = stack => dispatch => {
	const formData = new FormData();

	//add modeProvision file
	if (stack.data.provision.nodeProvisioner) {
		formData.append('nodeProvisioner', stack.data.provision.nodeProvisioner, stack.data.provision.nodeProvisioner.name);
	}

	if (stack.data.provision.serverProvisioner) {
		formData.append(
			'serverProvisioner',
			stack.data.provision.serverProvisioner,
			stack.data.provision.serverProvisioner.name
		);
	}

	if (stack.data.provision.dataFilesB) {
		stack.data.provision.dataFilesB.forEach(file => {
			formData.append(file.name, file);
			stack.data.provision.dataFiles = stack.data.provision.dataFiles.filter(e => e !== file.name);
		});
	}

	delete stack.data.provision.dataFilesB;
	formData.set('stack', JSON.stringify(stack).replace('{}', '""'));

	dispatch(ActionsDialog.toggleLoading());
	const request = axios.post(`${API_BASE_URL}/api/stacks/`, formData, headers);
	return request
		.then(() => {
			dispatch(ActionsDialog.closeDialog());
			dispatch(getStacks());
			dispatch(ActionsDialog.toggleLoading());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setStackError({ ...err.data, type: 'form' }));
		});
};

export const finalizeBuildingCustomACMStack = (id) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.post(`${API_BASE_URL}/api/stacks/finalize-build`, { id }, headers);
	return request
		.then(() => {
			dispatch(ActionsDialog.closeDialog());
			dispatch(getStacks());
			dispatch(ActionsDialog.toggleLoading());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setStackError({ ...err.data, type: 'modal' }));
		});
};
// * ////////////// PUT ////////////// * //

export const editStack = stack => dispatch => {
	const formData = new FormData();

	//add modeProvision file
	if (stack.data.provision.nodeProvisioner.name) {
		formData.append('nodeProvisioner', stack.data.provision.nodeProvisioner, stack.data.provision.nodeProvisioner.name);
	}

	if (stack.data.provision.serverProvisioner.name) {
		formData.append(
			'serverProvisioner',
			stack.data.provision.serverProvisioner,
			stack.data.provision.serverProvisioner.name
		);
	}
	if (stack.data.provision.dataFilesB) {
		stack.data.provision.dataFilesB.forEach(file => {
			formData.append(file.name, file);
			stack.data.provision.dataFiles = stack.data.provision.dataFiles.filter(e => e !== file.name);
		});
	}

	delete stack.data.provision.dataFilesB;
	formData.set('stack', JSON.stringify(stack).replace('{}', '""'));

	dispatch(ActionsDialog.toggleLoading());
	const request = axios.put(`${API_BASE_URL}/api/stacks/`, formData, headers);
	return request
		.then(() => {
			dispatch(ActionsDialog.closeDialog());
			dispatch(getStacks());
			dispatch(ActionsDialog.toggleLoading());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setStackError({ ...err.data, type: 'form' }));
		});
};

export const editCollaborators = data => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.put(`${API_BASE_URL}/api/stacks/collaborators`, data, headers);
	return request
		.then(res => {
			dispatch(setSelected(res.data.stack));
			dispatch(ActionsDialog.toggleLoading());
			dispatch(getStacks());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setStackError({ ...err.data, type: 'modal' }));
		});
};

// * ////////////// DELETE ////////////// * //

export const deleteStack = (id, provider) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.delete(`${API_BASE_URL}/api/stacks/${id}`, {
		headers,
		data: { provider }
	});
	return request
		.then(() => dispatch(getStacks()))
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(showMessage({ message: 'Stack Deleted' }));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			const errorMessage = err?.response?.data?.message || 'An error occurred while deleting the stack';
			dispatch(setStackError({ message: errorMessage, type: 'modal' }));

		});
};

// * ////////////// ACTIONS ////////////// * //

export const buildStack = (stackId, stacksArray) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());

	const payload = { id: stackId, stacks: stacksArray };
	const request = axios.post(`${API_BASE_URL}/api/stacks/build`, payload, headers);

	return request
		.then(() => {
			dispatch(ActionsDialog.closeDialog());
			dispatch(getStacks());
			dispatch(ActionsDialog.toggleLoading());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setStackError({ ...err.data, type: 'modal' }));
		});
};

export const getStackError = (stackId) => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/stacks/error/${stackId}`, headers);
	
	return request
		.then(response => {
			if (response.data && response.data.error) {
				// Show dialog with error instructions
				const error = response.data.error;
				const isWarning = error.instructions?.severity === 'warning';
				
				dispatch(ActionsDialog.openDialog({
					maxWidth: 'md',
					fullWidth: true,
					children: (
						<React.Fragment>
							<DialogTitle id="alert-dialog-title">
								<div className="flex items-center">
									<Icon 
										style={{ 
											color: isWarning ? '#ff9800' : '#f44336',
											fontSize: '28px',
											marginRight: '12px'
										}}
									>
										{isWarning ? 'warning' : 'error_outline'}
									</Icon>
									<Typography variant="h6" component="span" className="font-bold">
										{error.instructions?.title || 'Stack Build Error'}
									</Typography>
								</div>
							</DialogTitle>
							<DialogContent className="p-24">
								{/* Error Type Badge */}
								<div 
									style={{
										backgroundColor: isWarning ? 'rgba(255, 152, 0, 0.1)' : 'rgba(244, 67, 54, 0.1)',
										borderRadius: '4px',
										padding: '6px 12px',
										display: 'inline-block',
										marginBottom: '16px'
									}}
								>
									<Typography 
										variant="caption" 
										style={{ 
											color: isWarning ? '#ff9800' : '#f44336',
											fontWeight: 'bold',
											fontSize: '12px'
										}}
									>
										{error.type}
									</Typography>
								</div>

								{/* Main Message */}
								{error.instructions?.message && (
									<Typography variant="body1" paragraph style={{ marginBottom: '24px' }}>
										{error.instructions.message}
									</Typography>
								)}

								{/* CLI Remediation */}
								{error.instructions?.remediation?.cli?.description && (
									<div style={{ marginBottom: '24px' }}>
										<Typography variant="body2" color="textSecondary" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
											✓ Solution - {error.instructions.remediation.cli.description}
										</Typography>
										{error.instructions.remediation.cli.command && (
											<div style={{ marginTop: '12px' }}>
												<pre style={{
													backgroundColor: '#263238',
													color: '#aed581',
													padding: '16px',
													borderRadius: '4px',
													overflow: 'auto',
													fontSize: '13px',
													fontFamily: '"Monaco", "Menlo", "Ubuntu Mono", "Consolas", monospace',
													border: '1px solid rgba(255, 255, 255, 0.1)',
													margin: 0
												}}>
													<code>{error.instructions.remediation.cli.command}</code>
												</pre>
												<Typography 
													variant="caption" 
													color="textSecondary" 
													style={{ 
														display: 'block',
														marginTop: '8px',
														fontStyle: 'italic'
													}}
												>
													💡 Copy and run this command in Azure CLI
												</Typography>
											</div>
										)}
									</div>
								)}

								{/* Portal Link */}
								{error.instructions?.remediation?.portal?.url && (
									<div style={{ 
										marginBottom: '24px',
										padding: '12px 16px',
										backgroundColor: 'rgba(33, 150, 243, 0.08)',
										borderRadius: '4px',
										borderLeft: '4px solid #2196f3'
									}}>
										<Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
											Alternative: Use Azure Portal
										</Typography>
										<a 
											href={error.instructions.remediation.portal.url} 
											target="_blank" 
											rel="noopener noreferrer"
											style={{ 
												color: '#2196f3',
												textDecoration: 'none',
												display: 'flex',
												alignItems: 'center',
												fontWeight: 500
											}}
										>
											<Icon style={{ fontSize: '18px', marginRight: '6px' }}>open_in_new</Icon>
											{error.instructions.remediation.portal.description || 'Open in Azure Portal'}
										</a>
										{error.instructions.remediation.portal.note && (
											<Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: '8px' }}>
												{error.instructions.remediation.portal.note}
											</Typography>
										)}
									</div>
								)}

								{/* Next Steps */}
								{error.instructions?.nextSteps && error.instructions.nextSteps.length > 0 && (
									<div style={{ marginBottom: '16px' }}>
										<Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '12px' }}>
											📋 Next Steps:
										</Typography>
										<ol style={{ 
											paddingLeft: '24px',
											margin: 0
										}}>
											{error.instructions.nextSteps.map((step, idx) => (
												<li key={idx} style={{ marginBottom: '8px' }}>
													<Typography variant="body2" color="textSecondary">
														{step}
													</Typography>
												</li>
											))}
										</ol>
									</div>
								)}

								{/* Generic Error Details (for UNKNOWN errors) */}
								{error.type === 'UNKNOWN' && error.instructions?.details && (
									<div style={{ marginBottom: '16px' }}>
										{error.instructions.details.failedComponent && (
											<div style={{ marginBottom: '12px' }}>
												<Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '4px' }}>
													Failed Component:
												</Typography>
												<Typography variant="body2" color="textSecondary">
													{error.instructions.details.failedComponent}
												</Typography>
											</div>
										)}
										
										{error.instructions.details.errorCodes && error.instructions.details.errorCodes.length > 0 && (
											<div style={{ marginBottom: '12px' }}>
												<Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '4px' }}>
													Error Codes:
												</Typography>
												<div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
													{error.instructions.details.errorCodes.map((code, idx) => (
														<span 
															key={idx}
															style={{
																backgroundColor: 'rgba(244, 67, 54, 0.1)',
																color: '#f44336',
																padding: '4px 8px',
																borderRadius: '4px',
																fontSize: '12px',
																fontFamily: 'monospace'
															}}
														>
															{code}
														</span>
													))}
												</div>
											</div>
										)}
										
										{error.instructions.details.errorMessages && error.instructions.details.errorMessages.length > 0 && (
											<div style={{ marginBottom: '12px' }}>
												<Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
													Error Messages:
												</Typography>
												<div style={{
													backgroundColor: '#fff3e0',
													borderLeft: '4px solid #ff9800',
													padding: '12px',
													borderRadius: '4px'
												}}>
													{error.instructions.details.errorMessages.map((msg, idx) => (
														<Typography 
															key={idx} 
															variant="body2" 
															style={{ 
																marginBottom: idx < error.instructions.details.errorMessages.length - 1 ? '8px' : 0,
																fontFamily: '"Monaco", "Menlo", "Ubuntu Mono", "Consolas", monospace',
																fontSize: '12px'
															}}
														>
															{msg}
														</Typography>
													))}
												</div>
											</div>
										)}
									</div>
								)}

								{/* Timestamp */}
								{error.timestamp && (
									<Typography 
										variant="caption" 
										color="textSecondary" 
										style={{ 
											display: 'block',
											marginTop: '24px',
											paddingTop: '16px',
											borderTop: '1px solid rgba(0, 0, 0, 0.12)',
											fontSize: '11px'
										}}
									>
										⏰ Error occurred at: {new Date(error.timestamp).toLocaleString()}
									</Typography>
								)}
							</DialogContent>
							<DialogActions style={{ padding: '16px 24px' }}>
								<Button 
									onClick={() => {
										// Close current error dialog
										dispatch(ActionsDialog.closeDialog());
										// Fetch logs and show logs dialog
										const type = 'build';
										dispatch(getLogs({ id: stackId, type })).then(() => {
											// Get stack object from state
											axios.get(`${API_BASE_URL}/api/stacks/${stackId}`, headers)
												.then(res => {
													const stack = res.data;
													// Show logs dialog
													dispatch(ActionsDialog.openDialog({
														children: <Logs stack={stack} type={type} />,
														maxWidth: 'md',
														fullWidth: true,
														onClose: (event, reason) => {
															if (reason !== 'backdropClick') {
																dispatch(ActionsDialog.closeDialog());
															}
														}
													}));
												});
										});
									}} 
									color="default"
									variant="outlined"
									startIcon={<Icon>description</Icon>}
								>
									View Logs
								</Button>
								<Button 
									onClick={() => dispatch(ActionsDialog.closeDialog())} 
									color="primary" 
									variant="contained"
									autoFocus
								>
									Close
								</Button>
							</DialogActions>
						</React.Fragment>
					)
				}));
			} else {
				dispatch(showMessage({ message: 'No error details available for this stack', variant: 'info' }));
			}
		})
		.catch(err => {
			const errorMessage = err?.response?.data?.message || 'Failed to fetch error details';
			dispatch(showMessage({ message: errorMessage, variant: 'error' }));
		});
};
